export const KNOWLEDGE_BASES_SELF_ENDPOINT = '/p/v3/kb/knowledge-bases/self';
export const KNOWLEDGE_BASE_DOMAINS_ENDPOINT =
  '/p/v1/kb/knowledge-bases/:knowledgeBaseId/domains?domainStatus=ready';
